export const projects = [
  {
    title: "Job Portal App",
    description: "A modern full-stack MERN-based Job Portal connecting job seekers (students) and recruiters",
    technologies: [
  "React.js",
  "Tailwind CSS",
  "Node.js",
  "Express.js",
  "Mongoose",
  "JWT (Authentication)"
],
    liveUrl:"",
    codeUrl: "https://github.com/ahmad18697/Job-Portal"
  },
{
  title: "Doctor-Patient Finder Web App",
  description: "A full-stack web application that helps patients find nearby doctors based on location and specialty. It includes map integration and a simple UI for both patients and clinics.",
  technologies: [
    "React.js",
    "Tailwind CSS",
    "Node.js",
    "Express",
    "Leaflet / Google Maps API",
    "Browser Geolocation API"
  ],
  liveUrl: "https://doctor-patient-finder.vercel.app/",
  codeUrl: "https://github.com/ahmad18697/Doctor-Patient-Finder"
},
{
  title: "Inventory Management System",
  description: "A full-stack inventory management web application built using the MERN stack. It enables users to manage products, suppliers, and transactions with ease through a fast, responsive, and intuitive interface.",
  technologies: [
    "React",
    "Tailwind CSS",
    "Node.js",
    "Express.js",
    "MongoDB",
    "Mongoose"
  ],
  liveUrl: "https://inventory-management-system-pink-tau.vercel.app/",
  codeUrl: "https://github.com/ahmad18697/INVENTORY-MANAGEMENT-SYSTEM"
},
  {
    title: "Protein Structure Prediction using CNN",
    description: "Developed a pipeline predicting protein tertiary structure from amino acid sequences using CNNs and compared Random Forest, SVM, and ANN classifiers for optimal accuracy.",
    technologies: ["Python", "TensorFlow", "CNN", "Machine Learning"],
    liveUrl:"/PDB.png",
    codeUrl: "https://github.com/ahmad18697/Protein-Structure-Prediction-Using-CNN-Based-Feature-Extraction"
  },
  {
    title: "Crypto AR – Real-Time Cryptocurrency Tracker",
    description: "Built a responsive app to track live cryptocurrency prices and market trends.",
    technologies: ["React", "API Integration", "JavaScript", "CSS"],
    liveUrl: "https://cryoto-ar.vercel.app/",
    codeUrl: "https://github.com/ahmad18697/Cryoto_AR"
  },
  {
    title: "ChatGPT-powered Search Application",
    description: "Created a React-based search tool with ChatGPT API integration enabling AI-driven intelligent queries and real-time suggestions.",
    technologies: ["React", "ChatGPT API", "Node.js", "Express"],
    liveUrl: "https://summarizer-pi-three.vercel.app/",
    codeUrl: "https://github.com/ahmad18697/AI-Text-Summarizer"
  },
  {
  title: "Weather App 🌦",
  description: "Welcome to the Weather App! 🌍 This simple and modern application provides real-time weather updates and a 5-day forecast for any city using the OpenWeatherMap API.",
  technologies: [ "JavaScript", "OpenWeatherMap API","HTML", "CSS"],
  liveUrl: "https://weather-website-brown.vercel.app/",
  codeUrl: "https://github.com/ahmad18697/weather-website"
},
{
  title: "Ahmad Raza - Digital Services Landing Page",
  description: "A modern, sleek, and responsive website showcasing premium digital services, including web development, business automation, digital strategy, and security solutions — all aimed at accelerating business growth. Made with ❤️ using React.js and Tailwind CSS.",
  technologies: ["React.js", "Tailwind CSS", "JavaScript"],
  liveUrl: "https://landing-page-sigma-liart-37.vercel.app/",
  codeUrl: "https://github.com/ahmad18697/Landing_Page"
},
];
